<template>
    <LineChartGenerator
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </template>
  
  <script>
    import {
        Line as LineChartGenerator
    } from 'vue-chartjs/legacy'
  
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    CategoryScale,
    LinearScale
  } from 'chart.js'
  
  ChartJS.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale)
  
  export default {
    name: 'LineChart',
    components: {
        LineChartGenerator
    },
    props: {
      chartId: {
        type: String,
        default: 'Line-chart'
      },
      datasetIdKey: {
        type: String,
        default: 'label'
      },
      width: {
        type: Number,
        default: 400
      },
      height: {
        type: Number,
        default: 400
      },
      cssClasses: {
        default: '',
        type: String
      },
      styles: {
        type: Object,
        default: () => {}
      },
      plugins: {
        type: Array,
        default: () => []
      },
      chartData: {
          type: Object,
          default: () => ({
            labels: ['S1', 'S2', 'S3', 'S4', 'S5'],
            datasets: [{
                label: 'Pencapaian',
                data: [90, 75],
                backgroundColor: 'rgba(255,218,0,0.8)',
                borderColor: '#FFDA00'
            },{
                label: 'Saran',
                data: [90, 90, 90, 87, 90, 65],
                backgroundColor: 'rgba(214,0,255,0.8)',
                borderColor: '#D600FF'
            }]

          })
      },
      chartOptions: {
          type: Object,
          default: () => ({
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false
                }
            },
            scales: {
                  r: {
                      pointLabels: {
                          font: {
                              size: 14
                          }
                      },
                      ticks: {
                          display: false
                      }
                  },
                  x: {
                      grid: {
                      display: false
                      }
                  }
            },
          })
      },
    }
  }
  </script>
  